import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteExternalLink = (linkId: number) => {
  return axios.delete(`/api/external-links/${linkId}`);
};

type UseDeleteExternalLinkOptions = {
  config?: MutationConfig<typeof deleteExternalLink>;
};

export const useDeleteExternalLink = ({
  config,
}: UseDeleteExternalLinkOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['externalLinks']);
    },
    ...config,
    mutationFn: deleteExternalLink,
  });
};
